import { useReactiveVar } from "@apollo/client";
import { Text } from "@chakra-ui/react";
import { pdpQuantityVar } from "lib/apollo/variables";
import React from "react";
import { colours } from "@shared/ui.design-system";
import type { ItemClickBehaviour } from "@shared/graphql.types";
import { DescriptionLinksWrapper } from "./DescriptionLinksWarpper";

type Props = {
  brandName?: string;
  title?: string;
  subTitle?: string;
  titleColor?: string;
  descColor?: string;
  pdpUrlLink?: string;
  size?: string;
  descriptionVariant?: string;
  sizeFontVariant?: string;
  isPdp?: boolean;
  isInline?: boolean;
  source?: "HCL" | "CT";
  itemClickBehaviour?: ItemClickBehaviour;
  onProductClick?: () => void;
};

export const Description: React.FC<Props> = ({
  brandName = "",
  title = "",
  subTitle = "",
  titleColor,
  descColor,
  pdpUrlLink,
  size,
  descriptionVariant = "acuminLight",
  sizeFontVariant = "acuminLight",
  isInline = false,
  isPdp = false,
  source,
  itemClickBehaviour = "LINK",
  onProductClick
}) => {
  const quantity = useReactiveVar(pdpQuantityVar);
  const displayOption = isInline ? "inline" : "block";

  return (
    <>
      <DescriptionLinksWrapper
        displayOption={displayOption}
        titleColor={titleColor}
        itemClickBehaviour={itemClickBehaviour}
        source={source}
        onProductClick={onProductClick}
        pdpUrlLink={pdpUrlLink}
        titles={{ brandName, title, subTitle }}
        descriptionVariant={descriptionVariant}
        descColor={descColor}
      />
      <Text
        variant={sizeFontVariant}
        marginTop="0"
        color={descColor || colours.primary.dark}
        display={displayOption}
        {...(isInline
          ? {
              css: `
                :before {
                  content: " | ";
                  position: "relative";
                  color: ${colours.secondary.warm}
                }`
            }
          : {})}
      >
        {size}
      </Text>
      {isPdp && (
        <Text
          variant={sizeFontVariant}
          marginTop="0"
          color={descColor || colours.primary.dark}
        >
          {`Quantity: ${quantity}`}
        </Text>
      )}
    </>
  );
};
